import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=5f145721&scoped=true&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/_flow.scss?vue&type=style&index=0&id=5f145721&scoped=true&lang=scss&"
import style1 from "./CampaignSummary.vue?vue&type=style&index=1&id=5f145721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f145721",
  null
  
)

export default component.exports